module.exports = __webpack_public_path__ + "img/bluesky3100_33.32c94cd9.jpg";